import { render, staticRenderFns } from "./primary-kpi-tab.vue?vue&type=template&id=75914d87"
import script from "./primary-kpi-tab.vue?vue&type=script&lang=ts"
export * from "./primary-kpi-tab.vue?vue&type=script&lang=ts"
import style0 from "./primary-kpi-tab.vue?vue&type=style&index=0&id=75914d87&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75914d87')) {
      api.createRecord('75914d87', component.options)
    } else {
      api.reload('75914d87', component.options)
    }
    module.hot.accept("./primary-kpi-tab.vue?vue&type=template&id=75914d87", function () {
      api.rerender('75914d87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/primary-kpi-tab/primary-kpi-tab.vue"
export default component.exports